import axios from "axios"
import { AUTH_MODE, getAccessToken, getDevUser, triggerRelogin } from "@/store/auth"

// Dev-Auth: X-Dev-User-Header (nur lokal, AUTH_MODE=dev) — Stage/Prod: Logto-Bearer.
// Identitaet ueber store/auth.ts (localStorage "devUser", Default Rolle
// app:energie:leitung, damit Preise/SEU-Schreibpfade lokal testbar sind,
// ARCHITEKTUR.md §5 Berechtigungs-Sets).
function devHeaders(): Record<string, string> {
  if (AUTH_MODE !== "dev") return {}
  const dev = getDevUser()
  return {
    "X-Dev-User": JSON.stringify({ sub: dev.sub, name: dev.name, roles: dev.roles }),
  }
}

export const api = axios.create({
  // BASE_URL endet mit "/" — Root: "/api/v1", Pfad-Betrieb: "/energie/api/v1"
  baseURL: `${import.meta.env.BASE_URL}api/v1`,
})

// Logto-Modus: Bearer-Token pro Request frisch holen (Refresh macht @logto/react selbst).
// Dev-Modus: X-Dev-User-Header.
api.interceptors.request.use(async (config) => {
  if (AUTH_MODE === "dev") {
    Object.assign(config.headers, devHeaders())
    return config
  }
  const token = await getAccessToken()
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// 401 vom Backend (abgelaufene Session) → einmaliger Re-Login-Redirect (Logto-Modus).
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (axios.isAxiosError(error) && error.response?.status === 401) {
      triggerRelogin()
    }
    return Promise.reject(error)
  }
)
